<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>AREA<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" id="btn_division_save" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="divisions" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="divisionColumns" [selectionField]="'Division_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addDivision($event)" (editEntity)="editDivision($event)"
            (refreshEntities)="refreshDivisions($event)" (deleteEntity)="deleteDivision($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearDivision()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Area Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'DivisionName'" [(ngModel)]="entity.DivisionName" id="txt_Division_name"
                        ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        [fieldName]="'Code'" [(ngModel)]="entity.Code" id="txt_Division_code" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Area Head'" [formData]="entity" [data]="employees" [mandatory]="false"
                        [filterable]="true" (filterChanged)="getAllEmployees($event)" [class]="'form-control'"
                        [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                        id="drp_Division_head" [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee"
                        ngDefaultControl>
                    </dropdown>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllCompany($event)"
                        [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'" id="drp_Division_company"
                        [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                    </dropdown>
                </div> -->
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Region'" [formData]="entity" [data]="region" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllRegion($event)"
                        id="drp_Division_region" [(ngModel)]="entity.Region_Id" [textField]="'RegionName'"
                        [valueField]="'Region_Id'" [fieldName]="'Region_Id'" (selectionChanged)="Regionchanged($event)"
                        [selectedItem]="selectedRegion" ngDefaultControl>
                    </dropdown>

                </div>
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'State'" [formData]="entity" [data]="state" [class]="'form-control'"
                    [mandatory]="false" [filterable]="true"  id="drp_Division_state"
                    [(ngModel)]="entity.State_Id" [textField]="'StateName'" [valueField]="'State_Id'"
                    [fieldName]="'State_Id'"   [selectedItem]="selectedState" (selectionChanged)="Statechanged($event)" ngDefaultControl>
                </dropdown>
                </div> -->
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [formData]="entity" [maxlength]="100" [mandatory]="false"
                        id="txt_Division_Email" [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity" [mandatory]="false" [fieldName]="'Phone'"
                        id="txt_Division_phone" [(ngModel)]="entity.Phone" (keypress)="numberOnly($event)"
                        (paste)="onPaste($event)" [maxlength]="10" ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Zone'" [formData]="entity" [data]="zone" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true"  id="drp_Division_zone"
                        [(ngModel)]="entity.Zone_Id" [textField]="'ZoneName'" [valueField]="'Zone_Id'"
                        [fieldName]="'Zone_Id'" [selectedItem]="selectedZone" ngDefaultControl>
                    </dropdown>
                  
                </div> -->

            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <div class="row">

                <!-- <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" id="btn_division_save"
                        [disabled]="saveDisabled" [type]="'button'"></btn>
                </div> -->
            </div>
        </div>

    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
</ng-template>
<kendo-dialog title="Area Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="DivisionName" class="label label-1">Area Name : </label> {{details.DivisionName }}
        </div>
        <div class="col-md-4 br-table-data">
            <label for="Code" class="label label-1">Code : </label> {{details.Code}}
        </div>
        <div class="col-md-4 br-table-data">
            <label for="EmployeeName" class="label label-1">Area Head : </label> {{details.EmployeeName}}
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="RegionName" class="label label-1">Region : </label> {{details.RegionName}}
        </div>
        <div class="col-md-4 br-table-data">
            <label for="Email" class="label label-1">Email Id : </label> {{details.EmailId}}
        </div>
        <div class="col-md-4 br-table-data">
            <label for="Phone" class="label label-1">Phone Number : </label> {{details.Phone}}
        </div>
    </div>
</div>

</kendo-dialog>

<kendo-excelexport [data]="divisions.data" [collapsible]="true" fileName="Area.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DivisionName" title="Area" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DivisionCode" title="Code" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmployeeName" title="Head" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="ZoneName" title="Zone" [width]="200">
    </kendo-excelexport-column>     
    <kendo-excelexport-column field="StateName" title="State" [width]="200">
    </kendo-excelexport-column>      -->
    <kendo-excelexport-column field="DivisionMail" title="Email" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DivisionPhone" title="Phone" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="RegionName" title="Region" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>